// extracted by mini-css-extract-plugin
export var skipAnimation = "_z-0";